import apiAuth from 'src/clients/apiAuth';
import constants from 'src/constants/constants';

export default {
  loadPurchaseOffers(startDate, endDate, automatic = false) {
    let urlWithParams = constants.url.offerService.api.purchaseOffers.get + '?start=' + startDate + '&end=' + endDate;
    if (automatic) urlWithParams += '&creationType=automatic';
    return apiAuth({
      method: 'GET',
      baseURL: constants.url.offerService.baseUrl,
      url: urlWithParams,
    }).then((res) => res.data);
  },
  loadAcceptedPurchaseOffers() {},
  createPurchaseOffer({
    comment,
    variantKey,
    productKey,
    demandId,
    watchesToAccessDate,
    watchesOnStock,
    watchesToAccess,
    userEmail,
  }) {
    let options = {
      method: 'POST',
      url: constants.url.offerService.baseUrl + constants.url.offerService.api.purchaseOffers.create,
      data: {
        positionComment: comment,
        variantKey: variantKey,
        productKey: productKey,
        demandId: demandId,
        currency: 'EUR',
        watchesToAccessDate: watchesToAccessDate,
        watchesOnStock: watchesOnStock,
        watchesToAccess: watchesToAccess,
        userEmail: userEmail,
      },
    };

    return apiAuth(options).then((res) => res.data);
  },
  failPurchaseOffer(purchaseOfferId) {
    return apiAuth({
      method: 'POST',
      url:
        constants.url.offerService.baseUrl + constants.url.offerService.api.purchaseOffers.fail + '/' + purchaseOfferId,
    }).then((res) => res.data);
  },
  blockPurchaseOffer(purchaseOfferId, demandId) {
    return apiAuth({
      method: 'POST',
      baseURL: constants.url.offerService.baseUrl,
      url: constants.url.offerService.api.purchaseOffers.block + '/' + purchaseOfferId,
      data: { demandId: demandId },
    }).then((res) => res.data);
  },
  unblockPurchaseOffer(purchaseOfferId) {
    return apiAuth({
      method: 'POST',
      baseURL: constants.url.offerService.baseUrl,
      url: constants.url.offerService.api.purchaseOffers.unblock + '/' + purchaseOfferId,
    }).then((res) => res.data);
  },
  lastUpdateTimestamp() {},
  rejectPurchaseOffer(purchaseOfferId) {
    return apiAuth({
      method: 'POST',
      baseURL: constants.url.offerService.baseUrl,
      url: constants.url.offerService.api.purchaseOffers.reject,
      data: {
        purchaseOfferId: purchaseOfferId,
      },
    }).then((res) => res.data);
  },
};
